function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M429.7 145.7H87.2c-9.1 0-15.6 6.5-15.6 15.6v332.1c0 7.8 6.5 15.6 15.6 15.6h342.5c9.1 0 15.6-7.8 15.6-15.6V161.3c0-9.1-6.5-15.6-15.6-15.6zm22.1-106.4h-131V18.6c0-7.8-6.5-15.6-15.6-15.6h-93.4c-9.1 0-15.6 7.8-15.6 15.6v20.8H66.5c-9.1 0-16.9 6.5-16.9 15.6v45.4c0 9.1 7.8 16.9 16.9 16.9h385.3c7.8 0 15.6-7.8 15.6-16.9V54.9c0-9.1-7.8-15.6-15.6-15.6z"
})));